import { MRT_ColumnDef } from 'material-react-table';
import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';

import { hasAllPermissions, hasPermission, useCheckPermissions, useTableFilter } from '@/shared';
import { useFetchModeloProductos, useUpdateModeloProduct } from '@/shared/actions/erp';
import {
  CustomSearch,
  GeneralTable,
  SingleTableBoxScene,
  SwitchComponente,
} from '@/shared/components/ui';
import { MODELOPRODUCTOS } from '@/shared/interfaces/erp/inventario';
import { useUiConfirmModalStore } from '@/store/ui';
import { PermissionsEnum } from '@/auth/interfaces';

const returnUrl = '/inventario/modelo-productos';

export interface ModeloProductosPageInterface {}

const ModelosProductosPage: React.FC<ModeloProductosPageInterface> = () => {
  useCheckPermissions(PermissionsEnum.api_view_modelo)
  
  const navigate = useNavigate();

  const updSate = useUpdateModeloProduct({
    enableRedirect: false,
  });
 ///* global state
 const setConfirmDialog = useUiConfirmModalStore(s => s.setConfirmDialog);
 const setConfirmDialogIsOpen = useUiConfirmModalStore(
   s => s.setConfirmDialogIsOpen
 );
  ///* table
  const {
    globalFilter,
    pagination,
    searchTerm,
    onChangeFilter,
    setPagination,
  } = useTableFilter();
  const { pageIndex } = pagination;

  ///* fetch data
  const {
    data: modeloProductoPagingRes,
    isLoading,
    isRefetching,
  } = useFetchModeloProductos({
    page: pageIndex + 1,
    nombre: searchTerm,
  });


  ///* handlers
  const onEdit = (original: MODELOPRODUCTOS) => {
    navigate(`${returnUrl}/editar/${original.id_modelo}`);
  };

  ///* columns
  const columns = useMemo<MRT_ColumnDef<MODELOPRODUCTOS>[]>(
    () => [
      {
        accessorKey: 'numero_referencia',
        header: 'Numero referencia',
        size: 300,
      },
      {
        accessorKey: 'nombre',
        header: 'Nombre',
        size: 300,
      },
       {
        accessorKey: 'estado',
        header: 'Estado',
        size: 200,
        enableColumnFilter: false,
        enableSorting: false,
        Cell: ({ row }) => {
          return (
            <SwitchComponente
              estadoSwitch={row.original.estado}
              titulo={row.original.estado ? 'Activo' : 'Inactivo'}
              setEstadoSwitch={state => {
                if (!hasPermission(PermissionsEnum.api_change_modelo)) return;

                setConfirmDialog({
                  isOpen: true,
                  title: 'Cambiar Estado',
                  subtitle:
                    '¿Está seguro que desea cambiar el estado de este modelo producto ?',
                  onConfirm: () => {
                    setConfirmDialogIsOpen(false);
                    updSate.mutate({
                      id: row.original.id_modelo!,
                      data: { estado: !!state } as any,
                    });
                  },
                });
              }}
            />
          );
        },
      }
    ],
    []
  );

  return (
    <SingleTableBoxScene title="Modelo Productos" urlRedirect={`${returnUrl}/crear`}
     enableRedirect={true}>
      <CustomSearch onChange={onChangeFilter} value={globalFilter} text="modelo productos" />

      <GeneralTable<MODELOPRODUCTOS>
        columns={columns}
        data={modeloProductoPagingRes?.data?.data || []}
        //
        isLoading={isLoading}
        isRefetching={isRefetching}
        // // search
        enableGlobalFilter={false}
        enableColumnActions={hasAllPermissions([
          PermissionsEnum.api_change_modelo,
        ])}
        // // pagination
        pagination={pagination}
        onPaging={setPagination}
        rowCount={modeloProductoPagingRes?.data?.count}
        // // actions
        canEdit={hasAllPermissions([
          PermissionsEnum.api_change_modelo,
        ])}
        // crud
        onEdit={onEdit}
        canDelete={false}
      />
    </SingleTableBoxScene>
  );
};

export default ModelosProductosPage;
